// Generated by purs version 0.14.5
"use strict";
var Data_Nullable = require("../Data.Nullable/index.js");
var TofuHooks = require("../TofuHooks/index.js");
var useNullableRef = TofuHooks.useRef(Data_Nullable["null"]);
module.exports = {
    useNullableRef: useNullableRef
};
